import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { Picker } from '../../../components/Picker/Picker';
import { EmployerLayout } from '../Layout/EmployerLayout'
import classes from './AddJob.module.css'
import { ListItems } from './components/ListItems';
import { FieldComponent } from './components/FieldComponent';
import { authAxios, serverConn } from '../../../API/apiRequest';
import { RouteComponentProps, useHistory } from 'react-router-dom'
import validator from 'validator'
import { LoadingEmployerJob } from '../Job/EmployerJob';
import { Button } from '../../../components/Button/Button';
import { ModalComponent } from '../JobsManager/ApplicationCard/ApplicationCard';

const GenderOptions = [{label: 'ذكر', value: 'ذكر'}, {label: 'انثي', value: 'انثي'}, {label: 'لا يشترط', value: 'لا يشترط'}]
const salaryOptions = [{label: 'شهرياً', value: 'm'}]


const AddJob: React.FC<RouteComponentProps<{id?: string}>> = (props) =>{    

   
   const history = useHistory();
   const [requirements, setRequirements] = useState<string[]>([])
   const [advantages, setAdvantages] = useState<string[]>([])
   const [questions, setQuestions] = useState<string[]>([])
   const [isCV, setIsCV] = useState<boolean>(false)
   const [error, setError] = useState<string>('')
   const [employeeNumber, setEmployeeNumber] = useState<string>('')
   const [title, setTitle] = useState<string>('')
   const [description, setDescription] = useState<string>('')
   const [from, setFrom] = useState<string>('')
   const [to, setTo] = useState<string>('')
   const [salary, setSalary] = useState('')
   const [edit, setEdit] = useState<boolean>(false)
   const [showEndOption, setShowEndOption] = useState<boolean>(false)
   const [showEndJob, setShowEndJob] = useState<boolean>(false)
   const [fullDisabled, setFullDisable] = useState<boolean>(false)
   const [loadingJob, setLoadingJob] = useState<boolean>(true)
   const [saving, setSaving] = useState<boolean>(false)

   const [selectedGender, setSelectedGender] = useState<{label: string, value: string} | null>(null)
   const [selectedSalary, setSelectedSalary] = useState<{label: string, value: string} | null>(null)

   //JobType
   const [jobTypes, setJobTypes] = useState<[{label: string, value: string}] | []>([])
   const [selectedJobType, setSelectedJobType] = useState<{label: string, value: string} | null>(null)
   const [jobTypeLoading, setJobTypeLoading] = useState<boolean>(true)


   //EXP
   const [expOptions, setExpOptions] = useState<[{label: string, value: string}] | []>([])
   const [selectedExp, setSelectedExp] = useState<{label: string, value: string} | null>(null)
   const [expLoading, setExpLoading] = useState<boolean>(true)
   
   //EDU
   const [eduOptions, setEduOptions] = useState<[{label: string, value: string}] | []>([])
   const [selectedEdu, setSelectedEdu] = useState<{label: string, value: string} | null>(null)
   const [eduLoading, setEduLoading] = useState<boolean>(true)
   
   
   //Fields
   const [fields, setFields] = useState<[{label: string, value: string}] | []>([])
   const [selectedField, setSelectedField] = useState<{label: string, value: string} | null>(null)
   const [fieldLoading, setFieldLoading] = useState<boolean>(true)
  
   //Sp
   const [spOptions, setSpOptions] = useState<[{label: string, value: string}] | []>([])
   const [selectedSp, setSelectedSp] = useState<{label: string, value: string} | null>(null)
   const [spLoading, setSpLoading] = useState<boolean>(false)

   //Requirements
   const onAddRequirements = (v: string)=>{
      if(v.trim() !== '' && !requirements.includes(v)){
          setRequirements([...requirements, v])
      }
   }
   const onDeleteRequirements = (v: string)=>{
      setRequirements(requirements.filter((text)=>text !== v))
   }

   //Advantages
   const onAddAdvantages = (v: string)=>{
      if(v.trim() !== '' && !advantages.includes(v)){
          setAdvantages([...advantages, v])
      }
   }
   const onDeleteAdvantages = (v: string)=>{
      setAdvantages(advantages.filter((text)=>text !== v))
   }

   //Questions
   const onAddQuestions = (v: string)=>{
      if(v.trim() !== '' && !questions.includes(v)){
          setQuestions([...questions, v])
      }
   }
   const onDeleteQuestions = (v: string)=>{
      setQuestions(questions.filter((text)=>text !== v))
   }

   const onChangeField = async(value: any)=>{
         setError('')
         setSelectedSp(null)
         setSelectedField(value)
         try{
            setSpLoading(true)
            let sp_R = await serverConn.get(`/config/specialties?field=${value.value}`)
            setSpLoading(false)
            setSpOptions(sp_R.data.specialties)
         }catch(e){
          console.log(e)
         }
   }

   const onChangeNumber = (v: string)=>{
        setError('')
        setEmployeeNumber(v)
   }

    
    useEffect(()=>{

      async function getData(){
        try{
          //Get JobTypes
          const jobtypes_R = await serverConn.get('/config/jobtype')
          setJobTypes(jobtypes_R.data.jobTypes)
          setJobTypeLoading(false)
          //Get EXP
          const Exp_R = await serverConn.get('/config/exp')
          setExpLoading(false)
          setExpOptions(Exp_R.data.experience)
          //EDU
          const Edu_R = await serverConn.get('/config/edu/job')
          setEduLoading(false)
          setEduOptions(Edu_R.data.edu)
          //Fields
          const Field_R = await serverConn.get('/config/fields')
          setFieldLoading(false)
          setFields(Field_R.data.fields)
                  
        if(props.match.params.id){
          if(validator.isMongoId(props.match.params.id)){
                setEdit(true)
                try{
                  const jobR = await authAxios.get(`/employer/job/data/${props.match.params.id}`)
                  const { job } = jobR.data
                  setLoadingJob(false)
                  setTitle(job.title)
                  setDescription(job.description)
                  setIsCV(job.requireCV)
                  setEmployeeNumber(job.employeeNumber)
                  setSelectedJobType(job.type)
                  setSelectedEdu(job.edu)
                  setSelectedExp(job.exp)
                  onChangeField(job.field)
                  setSelectedSp(job.specialty)
                  setSelectedGender({label: job.gender, value: job.gender})
                  setRequirements(job.requirements)
                  setQuestions(job.questions)
                  setAdvantages(job.advantages)
                  if(job.salary !== 'يتم التحديد عند المقابلة'){
                    let s = job.salary.match(/\d+/)[0]
                    setSalary(s)
                    setSelectedSalary({label: 'شهرياً', value: 'm'})
                  }
                  setFrom(job.from)
                  setTo(job.to)
                  if(job.status === 'تم النشر'){
                    setShowEndOption(true)
                  }else if (job.status === 'تمت'){
                    setFullDisable(true)
                  }
                  setLoadingJob(false)
                }catch(e){
                  console.log(e)
                  history.replace('/404')
                }
               
            } 
            else{
                history.replace('/404')
            }
        }
        setLoadingJob(false)

      }catch(e){
        console.log(e)
      }
        
      }

     
      getData()
      
    },[props.match.params.id, history])


    const EndJob = async()=>{
      try{
        if(props.match.params.id && validator.isMongoId(props.match.params.id)){
          let result = await authAxios.post(`employer/job/${props.match.params.id}/end`)
          if(result.status === 200){
            console.log('Status changed')
            setShowEndOption(false)
            setFullDisable(true)
            return setShowEndJob(false)
          }
        }

      }catch(e){
        console.log(e)
      }
    }

    const onSubmit = async()=>{
        
      try{
        if(edit){
          if(description.trim() === '' || description.trim().length < 5){
            return setError('من فضلك قم بكتابة وصف الوظيفة')
          }
          let result = await authAxios.put(`employer/job/${props.match.params.id}`, {
            description,
            advantages,
            requirements
          })
          if(result.status === 200){
            return history.replace('/employer/jobs')
          }

        }else{
          if(employeeNumber.trim().length === 0 || isNaN(parseInt(employeeNumber))){
            return setError('من فضلك قم بكتابة عدد الموظفين المطلوبين')
          }
          if(title.trim() === '' || title.trim().length < 3 || title.trim().length > 40){
            return setError('من فضلك قم بكتابة عنوان الوظيفة')
          }
          if(description.trim() === '' || description.trim().length < 5){
            return setError('من فضلك قم بكتابة وصف الوظيفة')
          }
          if(!selectedEdu){
            return setError('من فضلك قم بإختيار المؤهل')
          }
          if(!selectedJobType){
            return setError('من فضلك قم بإختيار نوع الوظيفة')
          }
          if(!selectedExp){
            return setError('من فضلك قم بإختيار المستوي الوظيفي')
          }
          if(!selectedField){
            return setError('من فضلك قم بإختيار المجال')
          }
          if(!selectedSp){
            return setError('من فضلك قم بإختيار التخصص')
          }
          if(!selectedGender){
            return setError('من فضلك قم بإختيار النوع')
          }
          if(salary.trim() !== '' && selectedSalary === null){
            return setError('من فضلك قم بإختيار المدة او اترك الراتب فارغ')
          }
          if(edit && props.match.params.id){
              
          }else{
            setSaving(true)
            await authAxios.post('employer/job', {
              title,
              description,
              exp: selectedExp.value,
              edu: selectedEdu.value,
              field: selectedField.value,
              specialty: selectedSp.value,
              jobType: selectedJobType.value,
              employeeNumber,
              from,
              to,
              gender: selectedGender.value,
              requireCV: isCV,
              salary,
              salaryTime: selectedSalary?.value,
              questions,
              advantages,
              requirements
            })
        }
          setSaving(false)
          return history.replace('/employer/jobs')
      }

      }catch(e: any){
        if(e.response === undefined) return
        if(e?.response?.data){
          setError(e.response.data.errors[0])
        }
        console.log(e.response.data)
        setSaving(false)

      }


    }

    if(loadingJob) return <LoadingEmployerJob />
    return(
       <EmployerLayout>
            <ModalComponent
         show={showEndJob}
         accept={EndJob}
         reject={()=>{setShowEndJob(false)}}
         title='تأكيد ايقاف الوظيفة'
        >
             <h5 style={{textAlign: 'right'}}>هل ترغب في ايقاف هذه الوظيفة؟</h5>
        </ModalComponent>
        {showEndOption && <Row style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
        <Button 
            loading={saving} 
            style={{marginBottom: 25, width: '97%'}} 
            height={30} 
            color='darkred'
            hoverColor='#FF5733'
            onPress={()=>setShowEndJob(true)}>انهاء الوظيفة</Button>
        </Row>}
        <Row>
          <FieldComponent 
              value={employeeNumber} 
              onChangeValue={onChangeNumber} 
              width={80} 
              title='عدد الموظفين المطلوبين' 
              placeholder='العدد' 
              inputType='number'
              disabled={edit}
            />
          <FieldComponent 
              width={250} 
              title='عنوان الوظيفة' 
              placeholder='العنوان' 
              value={title}
              onChangeValue={(v)=>{setTitle(v); setError('')}}
              disabled={edit}
              
            />
        </Row>
          <FieldComponent 
            title='الوصف' 
            text 
            placeholder='وصف للوظيفة' 
            value={description}
            onChangeValue={(v)=>{setDescription(v); setError('')}}
            disabled={fullDisabled}
          />
        <Row>
          <Col>
            <p className={classes.fieldTitle}>المستوي الوظيفي</p>
            <Picker 
              color='#fff' 
              placeholder='اختر المستوي الوظيفي'
              options={expOptions}
              onChange={(value)=>{setSelectedExp(value); setError('')}}
              loading={expLoading}
              value={selectedExp}
              fontColor='#000'
              disabled={edit}
            />
          </Col>
          <Col>
            <p className={classes.fieldTitle}>نوع الوظيفة</p>
            <Picker 
              color='#fff' 
              placeholder='نوع الوظيفة' 
              options={jobTypes}
              loading={jobTypeLoading}
              onChange={(value)=>{setSelectedJobType(value); setError('')}}
              value={selectedJobType}
              fontColor='#000'
              disabled={edit}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <p className={classes.fieldTitle}>المؤهل</p>
            <Picker 
              color='#fff' 
              placeholder='اختر المؤهل' 
              options={eduOptions}
              value={selectedEdu}
              loading={eduLoading}
              onChange={(value)=>{setSelectedEdu(value); setError('')}}
              fontColor='#000'
              disabled={edit}
              />
          </Col>
          <Col>
            <p className={classes.fieldTitle}>مجال الوظيفة</p>
            <Picker 
              color='#fff' 
              placeholder='اختر المجال' 
              options={fields}
              loading={fieldLoading}
              value={selectedField}
              onChange={onChangeField}
              fontColor='#000'
              disabled={edit}              
            />
          </Col>
          
        </Row>
        <Row>
          <Col>
            <p className={classes.fieldTitle}>التخصص</p>
            <Picker 
                color='#fff' 
                placeholder={selectedField === null ? 'اختر المجال اولاً' : 'اختر تخصص الوظيفة'} 
                disabled = {selectedField === null ? true : edit}
                loading={spLoading}
                onChange={(value)=>{setSelectedSp(value); setError('')}}
                options={spOptions}
                value={selectedSp}
                fontColor='#000'
              />
          </Col>
          <Col>
            <p className={classes.fieldTitle}>النوع</p>
            <Picker 
            color='#fff' 
            placeholder='اختر النوع' 
            options={GenderOptions}
            value={selectedGender}
            onChange={(value)=>{setSelectedGender(value); setError('')}}
            fontColor='#000'
            disabled={edit}
            />
          </Col>
        </Row>
        <Row>
          <Col style={{display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', alignItems: 'flex-end'}}>
          <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
            <p className={classes.tip}>(يمكنك ترك الخانة فارغة)</p>
            <p className={classes.fieldTitle}>السن</p>
            </div>
            <div style={{display: 'flex', flexDirection: 'row-reverse', alignItems: 'center', justifyContent: 'flex-end'}}>
              <p style={{color: '#fff', marginLeft: 5, fontSize: 15}}>الحد الادني</p>
               <input 
                 className={classes.myInput}
                 style={{width: 40}}
                 value={from}
                 onChange={({target})=>setFrom(target.value)}
                 placeholder='0'
                 type='number'
                 disabled={edit}
                 min={0}
               />
               <p style={{color: '#fff', marginLeft: 5, marginRight: 8, fontSize: 15}}>الحد الاقصي</p>
               <input 
                 className={classes.myInput}
                 style={{width: 40}}
                 value={to}
                 type='number'
                 onChange={({target})=>setTo(target.value)}
                 placeholder='0'
                 disabled={edit}
                 min={0}
               />
            </div>
          </Col>
        </Row>
        <Row>
          <Col style={{display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', alignItems: 'flex-end'}}>
            <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
            <p className={classes.tip}>(يمكنك ترك الخانة فارغة)</p>
            <p className={classes.fieldTitle}>الراتب</p>
            </div>
            <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
            <Picker 
              placeholder='المدة' 
              color='#fff' 
              Width='130px'  
              options={salaryOptions}
              value={selectedSalary}
              onChange={(value)=>{setSelectedSalary(value); setError('')}}
              fontColor='#000'
              disabled={edit}
            />
            <input 
              placeholder='راتب الوظيفة' 
              style={{marginLeft: 10, width: 150}} 
              className={classes.myInput} 
              value={salary}
              onChange={({target})=>setSalary(target.value)}
              type='number'
              disabled={edit}
              min={0}
            />
            </div>
          </Col>
        </Row>
        <Row style={{marginTop: 35}}>
        <Col style={{display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', alignItems: 'flex-end'}}>
        <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
            <p className={classes.tip}>(يمكنك ترك الخانة فارغة)</p>
            <p className={classes.fieldTitle}>المتطلبات</p>
            </div>
        <ListItems disabled={fullDisabled} onDelete={onDeleteRequirements} onAdd={onAddRequirements} data={requirements} />
        </Col>
        </Row>
        <Row style={{marginTop: 25}}>
        <Col style={{display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', alignItems: 'flex-end'}}>
        <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
            <p className={classes.tip}>(يمكنك ترك الخانة فارغة)</p>
            <p className={classes.fieldTitle}>المميزات</p>
            </div>
        <ListItems disabled={fullDisabled} onDelete={onDeleteAdvantages} onAdd={onAddAdvantages} data={advantages} />
        </Col>
        </Row>
        <Row style={{marginTop: 25}}>
        <Col style={{display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', alignItems: 'flex-end'}}>
        <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
            <p className={classes.tip}>(يمكنك ترك الخانة فارغة)</p>
            <p className={classes.fieldTitle}>اسئلة عند التقديم</p>
            </div>
        <ListItems disabled={edit} onDelete={onDeleteQuestions} onAdd={onAddQuestions} data={questions} />
        </Col>
        </Row>
        <Row>
           <Col style={{display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', alignItems: 'flex-end'}}>
            <p className={classes.fieldTitle}>  ؟ (CV) هل هذه الوظيفة تتطلب ملف سيرة ذاتية </p>
            <label style={{color: '#fff', width: 50}} className={classes.container}>نعم
            <input type="radio" disabled={edit} checked={isCV} onChange={(event)=>setIsCV(true)} name="radio" />
            <span className={classes.checkmark}></span>
            </label>
            <label style={{color: '#fff', width: 50}} className={classes.container}>لا
            <input type="radio" disabled={edit} checked={!isCV} name="radio" onChange={()=>setIsCV(false)} />
            <span className={classes.checkmark}></span>
            </label>
           </Col>
        </Row>
        <Row style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
          <p className={classes.errText}>{error && error}</p>
          {!fullDisabled && <Button 
            loading={saving} 
            style={{marginBottom: 25,}} 
            height={60} 
            color='#1D8C49'
            hoverColor='#0e6b33'
            onPress={onSubmit}>{edit ? 'حفظ' : 'نشر الوظيفة'}</Button>}
        </Row>
       </EmployerLayout>
    )
}

export default AddJob